import * as yup from 'yup';
import { EmailSchema } from 'common/validation-schemas/Common.schema';
import { OrganizationRolesEnum } from 'common/enum/Organization.enum';

export const InviteUsersSchema = yup.object({
  role: yup.string().oneOf(Object.values(OrganizationRolesEnum)).required(),
  emails: yup.array().of(EmailSchema).min(1, 'At least 1 Email required').required(),
});
